'use client'
import React, { useState } from 'react'
import parse, { domToReact } from 'html-react-parser'
import tailwindConfig from '@tailwind.config'

const options = {
  replace: ({ name, attribs, children }) => {
    if (!attribs) return

    if (name === 'h1') {
      return (
        <h1 className="text-3xl font-bold mb-3 mt-3" {...attribs}>
          {domToReact(children, options)}
        </h1>
      )
    }
    if (name === 'h2') {
      return (
        <h2 className="text-2xl font-semibold mb-2 mt-2" {...attribs}>
          {domToReact(children, options)}
        </h2>
      )
    }
    if (name === 'h3') {
      return (
        <h3 className="text-xl font-semibold mb-1 mt-1" {...attribs}>
          {domToReact(children, options)}
        </h3>
      )
    }
    if (name === 'hr') {
      return (
        <hr className="text-xl font-semibold my-3" {...attribs} />
      )
    }
    if (name === 'strong') {
      return (
        <strong className="text-xl font-bold" {...attribs}>
          {domToReact(children, options)}
        </strong>
      )
    }
    if (name === 'a') {
      return (
        <a
          className="font-semibold hover:font-bold underline underline-offset-2"
          {...attribs}
        >
          {domToReact(children, options)}
        </a>
      )
    }
  },
}

const LandingPageDescription = ({ html, dictionary }) => {
  const [open, setOpen] = useState(false)

  const style = {
    color: tailwindConfig.theme.extend.colors.secondary,
  }

  return (
    <div className="mb-2 pb-2">
      
      {/* Toggle Button */}
      <button
        onClick={() => setOpen(prev => !prev)}
        className="lg:w-[150px] w-full px-2 py-1 rounded-lg bg-light border border-maincolor text-maincolor font-semibold hover:opacity-90 transition"
      >
        {open ? dictionary.search?.hideDetails : dictionary.search?.details}
      </button>

      {/* Content (only visible when open) */}
      {/* {open && ( */}
        <div className={`${open ? 'block' : 'hidden'} mt-4`} style={style}>
          {parse(`${html}`, options)}
        </div>
      {/* )} */}
    </div>
  )
}

export default LandingPageDescription
